module.exports = __webpack_public_path__ + "img/etaxone-investors.e5ac5ad.webp";